import { ReactNode } from 'react';
import { DemeterDashboardWidgetLayoutType, DemeterMarket, DemeterPageElementModel, DemeterPageElementType } from '../../../Generated/Raven-Demeter';
import { ComponentHeaderRightSideOptions } from '../../Components/Form/Inputs/ComponentMoreOptionsHorizontalDots';
import { TrackingEvent } from '../../Services/Tracking/TrackingService';

export interface IWithPageElementProps {
    pageElement?: DemeterPageElementModel;
    customTitle?: string | JSX.Element;
    dragIndicatorIcon?: ReactNode;
    isInDashboardEditMode?: boolean;
    maximizeMinimizeButton?: ComponentHeaderRightSideOptions.Maximize | ComponentHeaderRightSideOptions.Minimize;
    maxWidthHeightRatio?: number;
    selectedContracts?: string;
    useDynamicHeight?: boolean;
    widgetOptions?: { [key: string]: string };
    handleMoreOptionsSelection?: (value: ComponentHeaderRightSideOptions) => void;
    track: TrackingEvent;
}

export const pageElementsConstraintsAndInitializations: {
    pageElementType: DemeterPageElementType;
    layoutType?: DemeterDashboardWidgetLayoutType;
    initialLayoutType?: DemeterDashboardWidgetLayoutType;
    DefaultDashboardMarkets: DemeterMarket[];
    restrictToDairy?: boolean;
    rowOrder?: number;
}[] = [
    {
        pageElementType: DemeterPageElementType.LeadingIndicators,
        initialLayoutType: DemeterDashboardWidgetLayoutType.FullWidth,
        DefaultDashboardMarkets: [DemeterMarket.Grains, DemeterMarket.Dairy, DemeterMarket.Energy],
        rowOrder: 1,
    },
    {
        pageElementType: DemeterPageElementType.HedgeMonitorPro,
        initialLayoutType: DemeterDashboardWidgetLayoutType.FullWidth,
        DefaultDashboardMarkets: [DemeterMarket.Dairy, DemeterMarket.Energy, DemeterMarket.Grains],
        rowOrder: 2,
    },
    {
        pageElementType: DemeterPageElementType.CommodityIndicators,
        initialLayoutType: DemeterDashboardWidgetLayoutType.FullWidth,
        DefaultDashboardMarkets: [DemeterMarket.Dairy, DemeterMarket.Energy, DemeterMarket.Grains],
        rowOrder: 3,
    },
    {
        pageElementType: DemeterPageElementType.MarketIntelligenceReports,
        layoutType: DemeterDashboardWidgetLayoutType.FullWidth,
        DefaultDashboardMarkets: [DemeterMarket.Dairy, DemeterMarket.Energy],
        rowOrder: 4,
    },
    {
        pageElementType: DemeterPageElementType.ProjectionChart,
        DefaultDashboardMarkets: [DemeterMarket.Dairy],
        rowOrder: 5,
    },
    {
        pageElementType: DemeterPageElementType.MarginChart,
        DefaultDashboardMarkets: [DemeterMarket.Dairy],
        rowOrder: 5,
    },
    {
        pageElementType: DemeterPageElementType.PriceSummaries,
        layoutType: DemeterDashboardWidgetLayoutType.FullWidth,
        DefaultDashboardMarkets: [DemeterMarket.Dairy],
        rowOrder: 6,
    },
    {
        pageElementType: DemeterPageElementType.CommoditySummaryTable,
        layoutType: DemeterDashboardWidgetLayoutType.FullWidth,
        DefaultDashboardMarkets: [DemeterMarket.Grains, DemeterMarket.Dairy, DemeterMarket.Energy],
        rowOrder: 7,
    },
    {
        pageElementType: DemeterPageElementType.FuturesPricesTable,
        layoutType: DemeterDashboardWidgetLayoutType.FullWidth,
        DefaultDashboardMarkets: [],
    },
    {
        pageElementType: DemeterPageElementType.OtcPricesTable,
        layoutType: DemeterDashboardWidgetLayoutType.FullWidth,
        DefaultDashboardMarkets: [],
    },
    {
        pageElementType: DemeterPageElementType.PhysicalPricesTable,
        layoutType: DemeterDashboardWidgetLayoutType.FullWidth,
        DefaultDashboardMarkets: [],
    },
];
